import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { RecipeForm } from "@/features/recipes/components/recipe-form";
import { PageContainer } from "@/components/ui/page-container";

function NewRecipePage() {
  return (
    <PageContainer maxWidth="3xl">
      <RecipeForm />
    </PageContainer>
  );
}

export const newRecipeRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/recipes/new",
  component: NewRecipePage,
});
